import { Base } from "./base";

export class Unidade extends Base {
  public descricao!: string;
}
